/**
 * Adds to 32-bit signed integers.
 */
export const add32 = (a, b) => (a + b) | 0;
